export default "__VITE_ASSET__CqmZCRxN__"